import {RouteInfo} from './vertical-menu.metadata';
import {Controles} from '../constants/controles';

export const ROUTES: RouteInfo[] = [
  {
    path: '/page/dashboard',
    title: 'Dashboard',
    icon: 'ft-home',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    idcontro: 0,
    submenu: []
  },
  {
    path: '/',
    title: 'Factoraje',
    icon: 'ft-trending-up',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    idcontro: Controles.FACTORAJE_MENU,
    submenu: [
      {
        path: '/page/form-factoraje',
        title: 'Nueva solicitud',
        icon: 'ft-plus',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.FACTORAJE_NUEVA_SOLICITUD,
        submenu: []
      },
      {
        path: '/page/factoraje',
        title: 'Historial Solicitudes',
        icon: 'ft-trending-up',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: Controles.FACTORAJE_HISTORIAL_SOLICITUDES,
        submenu: []
      }
    ],
  },
  {
    path: '/page/fideicomiso',
    title: 'Fideicomisos',
    icon: 'ft-map',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    idcontro: Controles.FIDEICOMISOS_MENU,
    submenu: []
  },
  {
    path: '/',
    title: 'Utileria',
    icon: 'ft-settings',
    class: 'has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    idcontro: 0,
    submenu: [
      {
        path: '/page/clave',
        title: 'Cambio Contraseña',
        icon: 'ft-hash',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        idcontro: 0,
        submenu: []
      }
    ]
  }

];


